module.exports = __webpack_public_path__ + "static/media/news.5c7fcb2d.jpg";